import { render } from "./Questionnaires.vue?vue&type=template&id=eb558342"
import script from "./Questionnaires.vue?vue&type=script&lang=js"
export * from "./Questionnaires.vue?vue&type=script&lang=js"

import "./Questionnaires.vue?vue&type=style&index=0&id=eb558342&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__